module.exports = __webpack_public_path__ + "static/media/A15.2da898dd.png";